<template>
    <footer class="text-muted mt100">
      <div class="bootstrap-wrapper noprint">
        <div class="full-width footer-section">
            <div class="slanted">
                <div class="message">
                    <div class="follow-msg"><h4>FOLLOW US, WE DON'T BITE.</h4></div>
                    <div class="social-list">
                        <ul>
                            <li><a href="https://www.facebook.com/Zespri.Belgium" id="footernav_fblogo-109" meta="Facebook" target="_blank"><img src="//images.ctfassets.net/b7rvvweqeqmn/1ZVxizhPFMyShAWssFjwtK/d6e3433f408065ef1d7129a96a634c95/FB_ICON.png"></a>
                            </li>
                            <li><a href="https://www.instagram.com/zespri_kiwifruit_belgium/" id="footernav_iglogo-110" meta="Instagram" target="_blank"><img src="//images.ctfassets.net/b7rvvweqeqmn/3k0zjvAduqN1mh58KpLqHy/cc400513f0ef88263824d41be5875841/Zespri_Icons-2_10.png"></a>
                            </li>
                            <li><a href="https://twitter.com/zespri_benelux" id="footernav_twlogo-111" meta="Twitter" target="_blank"><img src="//images.ctfassets.net/b7rvvweqeqmn/6mJFy9H88Hg46SDbLAy5lC/f703e671193cbbad356a2df6f52deb88/_D_Zespri-Way_03.png"></a>
                            </li>
                            <li><a href="https://pinterest.com/source/zespri.eu/" id="footernav_ptlogo-113" meta="Pinterest" target="_blank"><img src="//images.ctfassets.net/b7rvvweqeqmn/4iVqTkyfEkjffhKJVABquf/f9127615226971d94a298f473d1e3c47/Zespri_05.png"></a>
                            </li>
                            <li><a href="https://www.youtube.com/channel/UC5L2_SGI1-FpXDy0Slo3bBQ" id="footernav_ytlogo-112" meta="YouTube" target="_blank"><img src="//images.ctfassets.net/b7rvvweqeqmn/5LFLZI2TmwX1gO2p86Ecob/eae9c303ca6351c37abd483490f41608/Zespri_D_Blog-Landing_Slicing_32.png"></a>
                            </li>
                        </ul>
                    </div>
                </div>
                <div class="footer-end">
                    <div class="row">
                        <div class="col-xl-6 col-lg-12">
                            <ul class="submenu-one">
                                <li><a href="/benl/contact" id="footernav_contactus-114">contact</a></li>
                            </ul>
                            <ul class="submenu-two">
                                <li><a :href="$t('footer.privacy.url')" id="footernav_pp-117">{{ $t('footer.privacy.title') }}</a></li>
                                <li><a :href="$t('footer.cookies.url')" id="footernav_tnc-118">{{ $t('footer.cookies.title') }}</a>
                                </li><li><a :href="$t('footer.disclaimer.url')" id="footernav_tnc-118b">{{ $t('footer.disclaimer.title') }}</a>
                                </li>
                            </ul>
                        </div>
                        <div class="col-xl-6 copyrght col-lg-12">
                            <div class="selectdiv dropdown">
                                <label>
                                    <select
                                        id="select_box"
                                        name="language"
                                        @change="changeLanguage"
                                    >
                                        <option
                                            v-for="lang in supportedLanguages"
                                            :key="lang"
                                            :selected="isCurrentLanguage(lang)"
                                            :class="{ 'is-selected': isCurrentLanguage(lang) }"
                                            :value="lang"
                                        >
                                        {{ $t('lang.'+lang) }}
                                        </option>
                                    </select>
                                <p>©Zespri Group Limited, all rights reserved</p>

                                    <p class="small">

                                        Zespri International (Europe) N.V.<br>

                                        Posthofbrug 10 bus 7<br>
                                        2600 Berchem (Antwerpen) België<br>
                                        <a href="mailto:info@zespri-europe.com">info@zespri-europe.com</a><br>
                                    </p>
                            </label>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        </div>
    </footer>
</template>

<script>
import { Trans } from '@/plugins/Translation'

export default {
  name: "Footer",
  computed: {
    supportedLanguages () {
      return Trans.supportedLanguages
    },
    currentLanguage () {
      return Trans.currentLanguage
    }
  },
  methods: {
    changeLanguage (lng) {
      const lang = lng.target.value;
      const to = this.$router.resolve({ params: { lang } })
      return Trans.changeLanguage(lang).then(() => {
        this.$router.push(to.location)
        location.reload();
      })
    },
    isCurrentLanguage (lang) {
      return lang === this.currentLanguage
    }
  }
}
</script>
